import "./@core/scss/core.css";

import * as serviceWorker from "./serviceWorker";

/* eslint-disable no-useless-escape */
import App from "./App";
import ReactDOM from "react-dom/client";

// ** Lazy load app

// TagManager.initialize(tagManagerArgs);
const container = document.getElementById("root");
const root = ReactDOM.createRoot(/** @type {HTMLElement} */ (container));
root.render(
    <App />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
